module.exports = __webpack_public_path__ + "img/history_btn.cd637fe1.png";